import { actionHandler } from '../../../../mergedSrc/utilities/form/formUtils';
import Text from '../../Global/Text';
import PropTypes from 'prop-types';

export const PriceCalculator = (
  { priceTitle, 
    commonFeesTitle, 
    showFees, 
    showProducts, 
    userData, 
    actions, 
    dispatch, 
    values, 
    setValues,
    feesDesc,
  }) => {

  const products = userData.productList
  
  return (
    <div className='price_calculator_main'>
      {showProducts &&
        products.map((item) => {
          const insurance = userData.staticQuotes[item].label
          const price = userData[`totalPrice-${item}`]
          return(
            <div key={item} className='product_price_details'>
              {insurance}forsikring
              <div>{Math.round(price)} <Text value="$[units.$[paymentFrequency]]" /></div>
            </div>
          )
        })
      }
      {(showFees && userData.totalPrice !== 0) && 
        <div className="common_fees">
          <Text value={commonFeesTitle} />
          <div>{userData.bsFees} <Text value="$[units.$[paymentFrequency]]" /></div>
        </div>
      }
      <div className="price_calculator_divider"></div>
      <div className='price_calculator_footer'>
        <div className='total_price'>
            <Text value={priceTitle} />
            <div>{userData.totalPrice !== 0 ? Math.round(userData.totalPrice + 9.5) : userData.totalPrice} <Text value="$[units.$[paymentFrequency]]" /></div>
        </div>
        {actions &&
          <div>
            <button
              type="button"
              className="modal_opener"
              onClick={e => actionHandler(actions, null, e, dispatch, values, setValues)}
            >
              <Text value={feesDesc} />
            </button>
          </div>
        }
      </div>
    </div>
  )
}

PriceCalculator.defaultProps = {
  showFees: true,
  showProducts: true
}

PriceCalculator.propTypes = {
  userData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  actions: PropTypes.array,
  priceTitle: PropTypes.string,
  commonFeesTitle: PropTypes.string,
  showFees: PropTypes.bool,
  showProducts: PropTypes.bool,
  feesDesc: PropTypes.string
}